(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-article"]) return;
  try {
    
  if (!customElements.get('rx-article-progress')) {
    customElements.define('rx-article-progress', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('span');
        this.wrap = this.closest('.rx-article');
        this.onScroll = this.update.bind(this);
        addEventListener('scroll', this.onScroll, { passive: true });
        addEventListener('resize', this.onScroll);
        this.update();
      }

      update() {
        if (!this.wrap || !this.bar) return;
        var rect = this.wrap.getBoundingClientRect();
        var total = rect.height - innerHeight;
        var read = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
        this.bar.style.transform = 'scaleX(' + read + ')';
      }

      disconnectedCallback() {
        removeEventListener('scroll', this.onScroll);
        removeEventListener('resize', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-beauty-advisor-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rx-advisor-page')) customElements.define('rx-advisor-page', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-advisor-form]')
      this.status = this.querySelector('[data-status]')
      this.results = this.querySelector('[data-results]')
      this.summary = this.querySelector('[data-summary]')
      this.recommendations = this.querySelector('[data-recommendations]')
      this.routineButton = this.querySelector('[data-add-routine]')
      this.routineLabel = this.querySelector('[data-routine-label]')
      this.routineUrls = []
      this.category = ''
      this.querySelectorAll('[data-category]').forEach(button => button.addEventListener('click', () => this.selectCategory(button)))
      this.form.addEventListener('submit', event => this.submit(event))
      this.form.addEventListener('reset', () => setTimeout(() => this.reset(), 0))
      this.routineButton.addEventListener('click', () => this.addRoutine())
    }

    selectCategory(selected) {
      this.category = selected.dataset.category
      this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button === selected)))
      this.querySelectorAll('[data-goals]').forEach(group => {
        group.hidden = group.dataset.goals !== this.category
        if (group.hidden) group.querySelectorAll('input').forEach(input => { input.checked = false })
      })
      this.status.textContent = ''
    }

    reset() {
      this.category = ''
      this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', 'false'))
      this.querySelectorAll('[data-goals]').forEach(group => { group.hidden = true })
      this.results.hidden = true
      this.status.textContent = ''
    }

    async submit(event) {
      event.preventDefault()
      const goal = this.querySelector('input[name=advisor-goal]:checked')
      if (!this.category || !goal) {
        this.status.textContent = this.dataset.required
        return
      }
      const submit = this.querySelector('[data-submit]')
      submit.disabled = true
      this.status.textContent = this.dataset.thinking
      try {
        const baseUrl = this.dataset.apiBaseUrl.replace(/\/$/, '')
        const profile = this.querySelector('[data-profile]').value.trim()
        const response = await fetch(`${baseUrl}/api/advisor/catalogue-recommendations`, {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ category: this.category, goals: [goal.value], profile, message: `Build a considered ${this.category} routine for ${goal.value}. ${profile}`, limit: 6, source: 'advisor_page' })
        })
        if (!response.ok) throw new Error('Advisor unavailable')
        this.render(await response.json())
        this.status.textContent = ''
      } catch (_error) {
        this.status.textContent = 'The advisor is briefly unavailable — please try again in a moment.'
      } finally {
        submit.disabled = false
      }
    }

    render(result) {
      this.summary.textContent = result.summary || result.rationale || this.dataset.summaryFallback
      this.recommendations.replaceChildren()
      this.routineUrls = []
      ;(result.recommendations || []).slice(0, 6).forEach(item => {
        const product = item.product || {}
        const safeProductUrl = this.safeUrl(product.onlineStoreUrl, '')
        if (safeProductUrl) this.routineUrls.push(safeProductUrl)
        const card = document.createElement('article')
        card.className = 'rx-advisor-page__recommendation'
        const link = document.createElement('a')
        link.className = 'rx-advisor-page__recommendation-media'
        link.href = safeProductUrl || '#'
        if (product.imageUrl) {
          const image = document.createElement('img')
          image.src = this.safeUrl(product.imageUrl, '')
          image.alt = product.title || ''
          image.loading = 'lazy'
          link.append(image)
        }
        const copy = document.createElement('div')
        const role = document.createElement('small')
        role.textContent = item.role || this.dataset.roleFallback
        const title = document.createElement('a')
        title.className = 'rx-advisor-page__recommendation-title'
        title.href = link.href
        title.textContent = product.title || this.dataset.productFallback
        const action = document.createElement('button')
        action.type = 'button'
        const actionLabel = document.createElement('span')
        actionLabel.textContent = this.dataset.addToCart
        const actionIcon = document.createElement('span')
        actionIcon.setAttribute('aria-hidden', 'true')
        actionIcon.textContent = '+'
        action.append(actionLabel, actionIcon)
        action.setAttribute('aria-label', `${this.dataset.addToCart}: ${product.title || this.dataset.productFallback}`)
        action.addEventListener('click', async () => {
          action.disabled = true
          action.setAttribute('aria-busy', 'true')
          const outcome = await this.addProductByUrl(safeProductUrl)
          action.removeAttribute('aria-busy')
          if (outcome === 'sold-out') {
            actionLabel.textContent = this.dataset.soldOut
            return
          }
          if (outcome === 'added') {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { source: 'rx-advisor-page' } }))
          }
          action.disabled = false
        })
        copy.append(role, title, action)
        card.append(link, copy)
        this.recommendations.append(card)
      })
      this.routineButton.hidden = this.routineUrls.length < 2
      this.routineButton.disabled = false
      this.routineLabel.textContent = 'Add the complete routine to cart'
      this.results.hidden = false
      this.results.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    async addRoutine() {
      if (!this.routineUrls.length) return
      this.routineButton.disabled = true
      let added = 0
      for (const url of this.routineUrls) {
        this.routineLabel.textContent = `Adding ${added + 1} of ${this.routineUrls.length}…`
        const outcome = await this.addProductByUrl(url)
        if (outcome === 'added') added += 1
      }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { source: 'rx-advisor-page' } }))
      this.routineLabel.textContent = added === this.routineUrls.length ? 'Routine added to cart' : `${added} of ${this.routineUrls.length} added — others unavailable`
    }

    async addProductByUrl(productUrl) {
      try {
        if (!productUrl) return 'failed'
        const source = new URL(productUrl, window.location.origin)
        if (source.origin !== window.location.origin) return 'failed'
        const productResponse = await fetch(`${source.pathname.replace(/\/$/, '')}.js`, { headers: { Accept: 'application/json' } })
        if (!productResponse.ok) return 'failed'
        const product = await productResponse.json()
        const requestedVariantId = Number(source.searchParams.get('variant'))
        const variant = product.variants.find(item => item.available && item.id === requestedVariantId) || product.variants.find(item => item.available)
        if (!variant) return 'sold-out'
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        })
        if (!cartResponse.ok) return 'failed'
        return 'added'
      } catch (_error) {
        return 'failed'
      }
    }

    safeUrl(value, fallback) {
      try {
        const url = new URL(value, window.location.origin)
        if (url.protocol === 'https:' || url.protocol === 'http:') return url.href
      } catch (_error) {
        return fallback
      }
      return fallback
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-concern-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rx-concern-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-rx-concern-track]');
    const previous = carousel.querySelector('[data-rx-concern-prev]');
    const next = carousel.querySelector('[data-rx-concern-next]');

    if (!track || !previous || !next) return;

    const move = (direction) => {
      const card = track.querySelector('.rx-concern');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-guided-brand-collection"] && !Shopify.designMode) return;
  try {
    
  class GuidedBrand extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-rx-guide-tab]')]
      this.panels = [...this.querySelectorAll('[data-rx-guide-panel]')]
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.rxGuideTab)))
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return
        const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
        const direction = event.key === 'ArrowRight' ? 1 : -1
        const next = (current + direction + this.tabs.length) % this.tabs.length
        this.select(this.tabs[next].dataset.rxGuideTab)
        this.tabs[next].focus()
      })
    }
    select(id) {
      this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.rxGuideTab === id)))
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.rxGuidePanel !== id })
    }
  }
  if (!customElements.get('guided-brand')) customElements.define('guided-brand', GuidedBrand)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-instagram-reel-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('instagram-reels')) {
    customElements.define('instagram-reels', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        this.load();
      }

      safeUrl(value, fallback = '') {
        try {
          const url = new URL(value, window.location.origin);
          if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
        } catch (error) {
          return fallback;
        }
        return fallback;
      }

      reelCard(item, profileUrl) {
        const article = document.createElement('article');
        article.className = 'rx-reels__card';
        article.setAttribute('role', 'listitem');

        const link = document.createElement('a');
        link.className = 'rx-reels__media';
        link.href = this.safeUrl(item.permalink, profileUrl);
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', item.caption ? `View Instagram Reel: ${item.caption}` : 'View Instagram Reel');

        const image = document.createElement('img');
        image.src = this.safeUrl(item.thumbnail_url || item.media_url);
        image.alt = item.caption || 'Reflexions Instagram Reel';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 720;
        image.height = 1280;
        link.append(image);

        const shade = document.createElement('span');
        shade.className = 'rx-reels__shade';
        link.append(shade);

        const play = document.createElement('span');
        play.className = 'rx-reels__play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10"></circle><path d="M10 8.5l6 3.5-6 3.5z"></path></svg>';
        link.append(play);

        const instagram = document.createElement('span');
        instagram.className = 'rx-reels__instagram';
        instagram.setAttribute('aria-hidden', 'true');
        instagram.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><rect x="3.5" y="3.5" width="17" height="17" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r=".8"></circle></svg>';
        link.append(instagram);

        if (item.caption) {
          const caption = document.createElement('span');
          caption.className = 'rx-reels__caption';
          caption.textContent = item.caption;
          link.append(caption);
        }

        article.append(link);
        return article;
      }

      async load() {
        const endpoint = this.dataset.endpoint;
        const track = this.querySelector('[data-reels-track]');
        const status = this.querySelector('[data-reels-status]');
        if (!endpoint || !track) return;

        try {
          const url = new URL(endpoint, window.location.origin);
          url.searchParams.set('limit', this.dataset.limit || '6');
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Feed request failed: ${response.status}`);
          const payload = await response.json();
          const items = Array.isArray(payload) ? payload : payload.data;
          if (!Array.isArray(items) || !items.length) return;

          const profileUrl = this.safeUrl(this.dataset.profileUrl, 'https://www.instagram.com/');
          const fragment = document.createDocumentFragment();
          items.slice(0, Number(this.dataset.limit) || 6).forEach((item) => {
            if (item && (item.thumbnail_url || item.media_url) && item.permalink) {
              fragment.append(this.reelCard(item, profileUrl));
            }
          });

          if (fragment.childElementCount) {
            track.replaceChildren(fragment);
            if (status) status.textContent = 'Latest Instagram Reels loaded.';
          }
        } catch (error) {
          if (status) status.textContent = 'Showing selected Instagram posts.';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-loyalty-page"] && !Shopify.designMode) return;
  try {
    
  class RxLoyaltyPage extends HTMLElement {
    connectedCallback() {
      this.updateBalance()
      window.setTimeout(() => this.updateBalance(), 1600)
    }

    updateBalance() {
      const balance = window.Smile?.customer?.points_balance
      const target = this.querySelector('[data-smile-balance]')
      if (target && Number.isFinite(Number(balance))) {
        target.textContent = `${Number(balance).toLocaleString()} points available`
      }
    }
  }

  if (!customElements.get('rx-loyalty-page')) customElements.define('rx-loyalty-page', RxLoyaltyPage)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-luxury-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rx-hero')) {
    customElements.define('rx-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-rx-hero-slide]')];
        this.dots = [...this.querySelectorAll('[data-rx-hero-dot]')];
        this.index = 0;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.rxHeroDot)));
        });

        this.show(0);

        if (
          this.dataset.autoplay === 'true' &&
          this.slides.length > 1 &&
          !matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          this.start();
        }
      }

      show(index) {
        this.index = index;

        this.slides.forEach((slide, position) => {
          slide.setAttribute('aria-hidden', String(position !== index));
        });

        this.dots.forEach((dot, position) => {
          if (position === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      start() {
        this.stop();
        const interval = Number(this.dataset.interval) || 6000;
        this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-pdp-luxury-prototype"] && !Shopify.designMode) return;
  try {
    
  class LuxuryProduct extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('.rx-luxury__hero-image')
      this.stage = this.querySelector('.rx-luxury__gallery-stage')
      this.index = this.querySelector('.rx-luxury__gallery-index')
      this.thumbnails = [...this.querySelectorAll('[data-gallery-image]')]
      this.thumbnails.forEach((button) => button.addEventListener('click', () => this.selectImage(button)))
      this.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => this.changeQuantity(button)))
      this.variantSelect = this.querySelector('[data-variant-select]')
      if (this.variantSelect) this.variantSelect.addEventListener('change', () => this.changeVariant())
      this.productForm = this.querySelector('.rx-luxury__form')
      this.handleProductSubmit = (event) => this.addToCart(event)
      if (this.productForm) this.productForm.addEventListener('submit', this.handleProductSubmit)
      this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > this.offsetTop + 420)
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll)
      if (this.productForm) this.productForm.removeEventListener('submit', this.handleProductSubmit)
    }

    async addToCart(event) {
      event.preventDefault()
      const button = this.querySelector('[data-add-button]')
      const status = this.querySelector('[data-form-status]')
      if (!this.productForm || !button || button.disabled || button.getAttribute('aria-busy') === 'true') return
      button.setAttribute('aria-busy', 'true')
      if (status) status.textContent = ''
      try {
        const formData = new FormData(this.productForm)
        formData.set('sections', 'cart-ajax')
        formData.set('sections_url', window.location.pathname)
        const shopRoot = window.Shopify?.routes?.root || '/'
        const variantId = Number(formData.get('id'))
        const requestedQuantity = Math.max(1, Number(formData.get('quantity') || 1))
        let quantityBefore = null
        try {
          const cartBeforeResponse = await fetch(`${shopRoot}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
          if (cartBeforeResponse.ok) {
            const cartBefore = await cartBeforeResponse.json()
            const itemBefore = cartBefore.items.find((item) => item.variant_id === variantId)
            quantityBefore = itemBefore ? itemBefore.quantity : 0
          }
        } catch (_error) {
          quantityBefore = null
        }
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        const responseText = await response.text()
        let data = null
        try {
          data = responseText ? JSON.parse(responseText) : null
        } catch (_error) {
          data = null
        }
        let addConfirmed = response.ok && data !== null
        if (!addConfirmed && quantityBefore !== null) {
          const cartAfterResponse = await fetch(`${shopRoot}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
          if (cartAfterResponse.ok) {
            const cartAfter = await cartAfterResponse.json()
            const itemAfter = cartAfter.items.find((item) => item.variant_id === variantId)
            const quantityAfter = itemAfter ? itemAfter.quantity : 0
            addConfirmed = quantityAfter >= quantityBefore + requestedQuantity
          }
        }
        if (!addConfirmed) {
          const apiMessage = data?.description || data?.message
          const message = response.status === 422 ? (apiMessage || this.dataset.cartLimit) : (apiMessage || this.dataset.cartError)
          throw new Error(message)
        }
        if (!data?.sections?.['cart-ajax']) {
          const sectionsResponse = await fetch(`${shopRoot}?sections=cart-ajax`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
          if (sectionsResponse.ok) {
            const sections = await sectionsResponse.json()
            data = { ...(data || {}), sections }
          }
        }
        this.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data, addToCartBtn: button }
        }))
      } catch (error) {
        const message = error.message || this.dataset.cartError
        if (status) status.textContent = message
        this.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          bubbles: true,
          detail: { errorMessage: message }
        }))
      } finally {
        button.removeAttribute('aria-busy')
      }
    }

    selectImage(button) {
      if (!this.image) return
      this.stage.classList.add('is-changing')
      this.thumbnails.forEach((thumbnail) => {
        const active = thumbnail === button
        thumbnail.classList.toggle('is-active', active)
        thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false')
      })
      window.setTimeout(() => {
        this.image.src = button.dataset.galleryImage
        this.image.srcset = button.dataset.gallerySrcset
        this.image.alt = button.dataset.galleryAlt
        if (this.index) this.index.textContent = `${String(button.dataset.galleryIndex).padStart(2, '0')} / ${String(this.thumbnails.length).padStart(2, '0')}`
        this.stage.classList.remove('is-changing')
      }, 180)
    }

    changeQuantity(button) {
      const input = this.querySelector('input[name="quantity"]')
      if (!input) return
      input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange))
    }

    changeVariant() {
      const option = this.variantSelect.selectedOptions[0]
      const price = this.querySelector('[data-product-price]')
      const button = this.querySelector('[data-add-button]')
      if (price) price.textContent = option.dataset.price
      if (button) button.disabled = option.dataset.available !== 'true'
      const url = new URL(window.location.href)
      url.searchParams.set('variant', option.value)
      window.history.replaceState({}, '', url)
    }
  }

  if (!customElements.get('luxury-product')) customElements.define('luxury-product', LuxuryProduct)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-salon-world"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rxsw]').forEach((root) => {
    const input = root.querySelector('[data-rxsw-search]');
    if (!input) return;
    const cards = Array.from(root.querySelectorAll('[data-rxsw-location]'));
    const empty = root.querySelector('[data-rxsw-empty]');
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const match = !query || card.dataset.search.includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
